import { render, staticRenderFns } from "./PaymentForm.vue?vue&type=template&id=00cb4e68&scoped=true"
import script from "./PaymentForm.vue?vue&type=script&lang=js"
export * from "./PaymentForm.vue?vue&type=script&lang=js"
import style0 from "./PaymentForm.vue?vue&type=style&index=0&id=00cb4e68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cb4e68",
  null
  
)

export default component.exports